module.exports = __webpack_public_path__ + "img/part4-uIcon11.acf8a3d9.png";